import { FirebaseAnalytics } from '@capacitor-firebase/analytics';
import { captureException } from '@sentry/vue';
import { useBaseDataStore } from '@/user/store/baseDataStore.ts';

function getAcceptedEmbeddings(): { gaAccepted: boolean } {
  if (!window.CCM?.acceptedEmbeddings) {
    return { gaAccepted: false };
  }

  const acceptedEmbeddings = window.CCM.acceptedEmbeddings;
  const fullConsentGiven = window.CCM.fullConsentGiven;

  if (fullConsentGiven && !acceptedEmbeddings.find(embedding => embedding.id === '679b4a1be2383aa0ee040e52')) {
    captureException(new Error('wrong G4 embedding id'))
  }

  const gaAccepted = acceptedEmbeddings.some(
    embedding => embedding.id === '679b4a1be2383aa0ee040e52'
  )

  return { gaAccepted };
}

export async function handleConsent() {
  const { gaAccepted } = getAcceptedEmbeddings();

  try {
    await FirebaseAnalytics.setEnabled({
      enabled: gaAccepted,
    })

    await FirebaseAnalytics.setUserId({
      userId: useBaseDataStore().hashedUserId,
    })

  } catch (error) {
    captureException(error);
  }
}
